import _ from 'lodash';
import globalStore from '$$globalStore';
import GanttWorker from '../workers/GanttWorker';

export default async function (links, fromGantt) {
  const tasksMap = globalStore.getters['tasksModel/tasksByIds'];
  const linksMap = globalStore.getters['tasksModel/linksByIds'];

  const updatedLinkMap = {};
  const updatedTaskMap = {};
  const updatedLinksForCommit = [];
  const updatedTasksForCommit = [];
  let refreshOverload = false;

  // Links update
  links.forEach(link => {
    if (!linksMap[link.id]) {
      throw 'Not found link for updating';
    }

    if (link.lag == linksMap[link.id].lag) {
      return;
    }

    updatedLinkMap[link.id] = { lag: link.lag };
    updatedLinksForCommit.push({ ...linksMap[link.id], lag: link.lag });
  });

  // Run worker (if needed)
  const needGanttWorker = !fromGantt && updatedLinksForCommit.length;
  let ganttWorkerData = null;

  if (needGanttWorker) {
    ganttWorkerData = await GanttWorker.calculate(updatedLinksForCommit, 'changeLinks', 'updateLinks');
    fromGantt = false;
  }

  if (ganttWorkerData) {
    _.forOwn(ganttWorkerData.diff.tasks, (diff, taskId) => {
      if (!updatedTaskMap[taskId]) {
        updatedTaskMap[taskId] = diff;
        updatedTasksForCommit.push({ id: +taskId, ...tasksMap[taskId], ...diff });
      }

      if (tasksMap[taskId] && tasksMap[taskId].resources?.length && !refreshOverload) {
        refreshOverload = true;
      }
    });
  }

  return {
    updatedLinksForCommit, updatedTasksForCommit, updatedLinkMap, updatedTaskMap, refreshOverload, fromGantt,
  };
}
